module.exports = __webpack_public_path__ + "static/016_001-f1f58b827a7ed1f30ded5079e0a693a8.jpg";